import { FC } from 'react';
import { Link } from 'react-router-dom';
import { routes } from 'routes';

import { Container } from 'views/components';
import { goToWP } from 'utils';
import styles from './Header.module.css';
import texts from './texts';
import { t } from 'utils';

export const Header: FC = () => {
  return (
    <div className={styles.bg}>
      <Container>
        <div className={styles.wrap}>
          <Link to={'#'} className={styles.link} onClick={() => goToWP('news-resources')}>
            {t(texts.topMenu.newsResources)}
          </Link>
          <Link className={styles.link} to={'#'} onClick={() => goToWP('support')}>
            {t(texts.topMenu.support)}
          </Link>
          <Link className={styles.link} to={'#'} onClick={() => goToWP('about')}>
            {t(texts.topMenu.about)}
          </Link>
          <Link className={styles.link} to={routes.signin}>
            {t(texts.topMenu.signin)}
          </Link>
        </div>
      </Container>
    </div>
  );
};
